import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IProjektStatiQueryShapes, ProjektStatiQueryFilterConfig } from 'fa-kt.types';
import { ProjektStatiService } from '../service';

@Component({
  selector: 'fa-kt-projekt-stati-filter',
  templateUrl: './projekt-stati-filter.component.html',
  styleUrls: ['./projekt-stati-filter.component.css'],
})
export class ProjektStatiFilterComponent {
  readonly subscriptions: Subscription[] = [];

  ProjektStatiFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public projektStati: ProjektStatiService,
  ) {
    this.ProjektStatiFilterConfig = ProjektStatiQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.projektStati.shapes$.subscribe((shapes: IProjektStatiQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ProjektStatiFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ProjektStatiFilterConfig[index].selections = shapes;
  }
}
